// extracted by mini-css-extract-plugin
export default {"player":"Stream_player__FUoc8"};